import { createTheme } from '@mui/material';
import { defaultStyleComponents } from './defaultStyleComponents';
import { defaultDarkColor, defaultLightColor } from './defaultColors';

export const greenLightTheme = createTheme({
  components: { ...defaultStyleComponents },
  spacing: (abs: number) => `${0.35 * abs}rem`,
  palette: {
    mode: 'light',
    primary: {
      main: '#46D369',
      900: '#0F2E14',
      800: '#1E5C28',
      700: '#2D8A3C',
      600: '#3CB850',
      500: '#46D369',
      400: '#6BDC87',
      300: '#90E5A5',
      200: '#B5EEC3',
      100: '#DAF7E1',
      50: '#EDFBF0',
    },
    ...defaultLightColor,
    customColor: {
      main: '#46D369',
      100: '#3CB850',
      gradient:
        'linear-gradient(90deg, rgba(70, 211, 105, 0.1) 0%, rgba(70, 211, 105, 0.3) 100%)',
    },
    customColor2: {
      main: '#141414',
    },
    customColorTable: {
      main: '#46D369',
      oddRow: '#EDFBF0',
    },
  },
});

export const greenDarkTheme = createTheme({
  components: { ...defaultStyleComponents },
  spacing: (abs: number) => `${0.35 * abs}rem`,
  palette: {
    mode: 'dark',
    primary: {
      main: '#46D369',
      900: '#141414',
      100: '#0F2E14',
      700: '#1E5C28',
      600: '#2D8A3C',
      500: '#3CB850',
      400: '#46D369',
      300: '#6BDC87',
      200: '#90E5A5',
      800: '#1a1a1a',
      50: '#262626',
    },
    ...defaultDarkColor,
    customColor: {
      main: '#46D369',
      100: '#6BDC87',
      gradient:
        'linear-gradient(90deg, rgba(20, 20, 20, 0.8) 0%, rgba(70, 211, 105, 0.3) 100%)',
    },
    customColor2: {
      main: '#141414',
    },
    customColorTable: {
      main: '#46D369',
      oddRow: '#1a1a1a',
    },
  },
});
